// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
/* Colours to be used */
/* Everything related to the Internationalization view */
/* Everything related to the Installation view */
/* Everything related to the navbar */
/* Everything related to alarm page list */
/* Everything related to alarm logs page */
/* Everything related to PWR table */
/*  */
.SensorCheckboxContainer_sensor-checkbox-checker__9FVSC .SensorCheckboxContainer_collapsed-true__gtLSM {
  background: #286090;
  border-radius: 0.3rem 0.3rem 0rem 0rem;
}
.SensorCheckboxContainer_sensor-checkbox-checker__9FVSC .SensorCheckboxContainer_collapsed-false__Apygg {
  border-radius: 0.3rem;
}
.SensorCheckboxContainer_sensor-checkbox-checker__9FVSC .SensorCheckboxContainer_title__yPH-n {
  margin-top: 0rem;
  margin-bottom: 0rem;
}
.SensorCheckboxContainer_sensor-checkbox-checker__9FVSC .SensorCheckboxContainer_collapsable-content__B0Cvb {
  background: #000;
  border-radius: 0rem 0rem 0.3rem 0.3rem;
  overflow: hidden;
}
.SensorCheckboxContainer_sensor-checkbox-checker__9FVSC .SensorCheckboxContainer_checkbox-container__J5Ubz {
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  color: white;
  font-weight: bold;
  font-size: 100%;
  padding: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/utils/_base.scss","webpack://./src/containers/SensorCheckboxContainer.module.scss","webpack://./src/utils/_utils.scss"],"names":[],"mappings":"AAAA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACCJ;ADCI;EACI,YAAA;EACA,aAAA;ACCR;ADEI;EACI,gBAAA;ACAR;;ADKA,uBAAA;AAQA,mBAAA;AEzBA,uBAAA;AAEA,wDAAA;AAGA,gDAAA;AAMA,qCAAA;AASA,0CAAA;AAKA,0CAAA;AAGA,oCAAA;AAMA,KAAA;AD5BI;EACI,mBCDgB;EDEhB,sCAAA;AAmBR;AAhBI;EACE,qBAAA;AAkBN;AAfI;EACE,gBAAA;EACA,mBAAA;AAiBN;AAdI;EACE,gBAAA;EACA,sCAAA;EACA,gBAAA;AAgBN;AAbI;EACE,aAAA;EACA,WAAA;EACA,sCAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EAEA,YAAA;EACA,iBAAA;EACA,eAAA;EAEA,eAAA;AAaN","sourcesContent":[null,"/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n/* Colours to be used */\n/* Everything related to the Internationalization view */\n/* Everything related to the Installation view */\n/* Everything related to the navbar */\n/* Everything related to alarm page list */\n/* Everything related to alarm logs page */\n/* Everything related to PWR table */\n/*  */\n.sensor-checkbox-checker .collapsed-true {\n  background: #286090;\n  border-radius: 0.3rem 0.3rem 0rem 0rem;\n}\n.sensor-checkbox-checker .collapsed-false {\n  border-radius: 0.3rem;\n}\n.sensor-checkbox-checker .title {\n  margin-top: 0rem;\n  margin-bottom: 0rem;\n}\n.sensor-checkbox-checker .collapsable-content {\n  background: #000;\n  border-radius: 0rem 0rem 0.3rem 0.3rem;\n  overflow: hidden;\n}\n.sensor-checkbox-checker .checkbox-container {\n  display: grid;\n  width: 100%;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  flex-direction: row;\n  justify-content: center;\n  flex-wrap: wrap;\n  color: white;\n  font-weight: bold;\n  font-size: 100%;\n  padding: 0.5rem;\n}",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sensor-checkbox-checker": `SensorCheckboxContainer_sensor-checkbox-checker__9FVSC`,
	"collapsed-true": `SensorCheckboxContainer_collapsed-true__gtLSM`,
	"collapsed-false": `SensorCheckboxContainer_collapsed-false__Apygg`,
	"title": `SensorCheckboxContainer_title__yPH-n`,
	"collapsable-content": `SensorCheckboxContainer_collapsable-content__B0Cvb`,
	"checkbox-container": `SensorCheckboxContainer_checkbox-container__J5Ubz`
};
export default ___CSS_LOADER_EXPORT___;
